import { render, staticRenderFns } from "./PricesetRuleDia.vue?vue&type=template&id=93d0ad2a&scoped=true"
import script from "./PricesetRuleDia.vue?vue&type=script&lang=js"
export * from "./PricesetRuleDia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93d0ad2a",
  null
  
)

export default component.exports